import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import {
    ArrayInput,
    AutocompleteInput,
    FormDataConsumer,
    NumberInput,
    ReferenceInput,
    SimpleForm,
    SimpleFormIterator,
    useNotify
} from "react-admin";
import Box from "@mui/material/Box";
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import {apiUrl, httpClient} from "../../../dataProvider";

interface Props {
    isOpen: boolean;
    setIsOpen: any;
    timeTableRefresh: boolean
    setTimeTableRefresh: any
    establishmentId: number
    initialValues: any
}

const renderOption = (data: any) => {
    if (data) {
        return `${data.name} (ID: ${data.id})`
    }
    return '';
};

const inputText = (record: any) => `${record.name} (ID: ${record.id})`;


export const ScheduleDayEditDialog = (props: Props) => {
    const handleClose = () => {
        props.setIsOpen(false);
    };
    const filterToQuery = (searchText:string) => ({ query: `%${searchText}%` });

    const notify = useNotify();

    return <Dialog open={props.isOpen} onClose={handleClose} fullWidth
                   maxWidth="sm">
        <DialogTitle>Beosztási nap szerkesztése</DialogTitle>
        <DialogContent>
            <SimpleForm toolbar={<></>} record={props.initialValues}>
                <ArrayInput source="requiredStuff" label={'Szükséges besoztottak'}
                            sx={{
                                '& .RaSimpleFormIterator-action': {
                                    paddingLeft: '15px'
                                },
                                '& .RaSimpleFormIterator-form': {
                                    marginTop: '12px',
                                    "& div": {
                                        marginBottom: '5px',
                                    }
                                },
                                '& .RaSimpleFormIterator-indexContainer': {
                                    display: 'none'
                                }
                            }}>
                    <SimpleFormIterator disableReordering>
                        <NumberInput fullWidth source="requiredStuffNumber" helperText={false}
                                     label={'Darab (kötelező)'} required/>
                        <ReferenceInput source="jobId"
                                        reference="job"
                                        name={"jobId"}
                                        filter={{establishmentId: props.establishmentId}}
                                        helperText={false}
                        >
                            <AutocompleteInput source="name"
                                               label={"Munka (kötelező)"}
                                               size={"small"}
                                               fullWidth
                                               isRequired
                                               inputText={inputText}
                                               optionText={renderOption}
                                               optionValue={"id"}
                                               helperText={false}
                                               filterToQuery={filterToQuery}
                            />
                        </ReferenceInput>
                    </SimpleFormIterator>
                </ArrayInput>
                <Box sx={{height: '30px'}}/>
                <FormDataConsumer>
                    {({formData, ...rest}) =>
                        <Button variant={'contained'}
                                startIcon={<SaveOutlinedIcon/>}
                                sx={{width: '100%', marginTop: '-10px'}}
                                onClick={async () => {
                                    await httpClient(`${apiUrl}/schedule-time-table/${props.initialValues.id}`, {
                                        method: 'PUT',
                                        body: JSON.stringify({
                                            establishmentId: props.establishmentId,
                                            requiredStuff: formData.requiredStuff,
                                            date: props.initialValues.date
                                        }),
                                    }).then(r => {
                                        if (r.status === 200) {
                                            props.setTimeTableRefresh(!props.timeTableRefresh);
                                            notify(`Beosztási nap módosítva`, {type: 'success'});
                                            props.setIsOpen(false)
                                        } else {
                                            notify(`Hiba történt a beosztási nap módosításakor`, {type: 'error'});
                                        }
                                    })
                                }}>
                            Mentés
                        </Button>
                    }
                </FormDataConsumer>
            </SimpleForm>
        </DialogContent>
    </Dialog>;
}
